<template>
  <section class="ut-p-6 prospect-stage-question">
    <h3 class="question-title">Let us know what went wrong, so we can do better next time</h3>
    <div>
      <div class="form-group">
        <textarea v-model="lowRatingReason"
          placeholder="The prospect was ..." class="ut-h-16">
        </textarea>
        <span class="error ut-text-sm ut-font-bold"
              v-show="validationError">
              Please enter a reason</span>
      </div>
    </div>
    <button @click="confirm()"
            class="btn btn-green-inverted confirm-btn"
            :class="{ 'disabled': disabledButtonClick }">Confirm</button>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import RadioButton from '@/components/Forms/RadioButton.vue';
import ProspectStageType from '@/Mapper/ProspectStageType';

export default {
  name: 'ProspectQualityQuesLowRatingReasonCustom',
  components: {
    RadioButton,
  },
  props: {
    prospect: {
      type: Object,
      required: true,
    },
    userid: {
      required: true,
    },
  },
  data() {
    return {
      lowRatingReason: '',
      validationError: false,
      disabledButtonClick: false,
    };
  },
  computed: {
    ...mapState({
      rating: state => state.prospectStore.rating,
    }),
  },
  created() {},
  methods: {
    ...mapActions('prospectStore', [
      'updateContactRating',
    ]),
    confirm() {
      if (this.disabledButtonClick) {
        return false;
      }

      if (!this.lowRatingReason) {
        this.validationError = true;
        return false;
      }

      this.disabledButtonClick = true;

      const payload = {
        ...this.rating,
        customResponse: this.lowRatingReason,
      };

      this.updateContactRating(payload).then(() => {
        this.$emit('update-view', 'contactedCallOutcomeAlt');
      }).catch((error) => {
        this.disabledButtonClick = false;
        console.error(error);
      });

      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/styles/prospect-stage-questions";
</style>
